import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";

export default function DateRangePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [tempRange, setTempRange] = useState(value);

  const handleApply = () => {
    if (tempRange?.from && tempRange?.to) {
      onChange(tempRange);
    }
    setOpen(false);
  };

  const handleClear = () => {
    onChange(null);
    setTempRange(null);
    setOpen(false);
  };

  const getDisplayText = () => {
    if (!value || !value.from) return "Select Date Range";
    if (value.from && value.to) {
      return `${format(value.from, "MMM dd")} - ${format(value.to, "MMM dd, yyyy")}`;
    }
    return `From ${format(value.from, "MMM dd, yyyy")}`;
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-start text-left font-normal rounded-xl border-neutral-300"
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {getDisplayText()}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="p-3">
          <Calendar
            mode="range"
            selected={tempRange ? { from: tempRange.from, to: tempRange.to } : undefined}
            onSelect={(range) => {
              if (range?.from) {
                setTempRange({ from: range.from, to: range.to });
              } else {
                setTempRange(null);
              }
            }}
            numberOfMonths={2}
            className="rounded-lg"
          />
          <div className="flex justify-end gap-2 mt-3 pt-3 border-t border-neutral-200">
            <Button
              variant="outline"
              size="sm"
              onClick={handleClear}
              className="rounded-lg"
            >
              Clear
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setOpen(false)}
              className="rounded-lg"
            >
              Cancel
            </Button>
            <Button
              size="sm"
              onClick={handleApply}
              disabled={!tempRange?.from || !tempRange?.to}
              className="bg-[#d4af37] hover:bg-[#b8941e] text-white rounded-lg"
            >
              Apply
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
